import { Search, RotateCcw } from "lucide-react";

export const marketingReportConfig: MarketingReportConfig = {
  title: "Marketing Report",
  stats: [
    {
      id: "search-volume",
      label: "Search Volume",
      value: "+2.9k",
      icon: Search,
      bg: "bg-pink-soft",
      color: "text-pink",
    },
    {
      id: "return-ratio",
      label: "Return Ratio",
      value: "1.22",
      icon: RotateCcw,
      bg: "bg-yellow-soft",
      color: "text-yellow",
    },
  ],
  donutData: [
    { value: 35, color: "#ffb800" },
    { value: 30, color: "#ff8c42" },
    { value: 35, color: "#13c2c2" },
  ],
};
